/**
* Privacy checkbox
*/

const orderPrivacy = () => {
  const privacyBlock = document.querySelector(".is-privacy");
  if(!privacyBlock) return;  
  const privacyError = privacyBlock.querySelector('.form__error');
  const privacyContent:any = document.querySelector(".js-privacy")
  const privacyCheck:any = document.querySelector('[name="agree"]');
  const submitBtn:any = document.querySelector('[name="complete"]');
  const errorMsg = "チェックを入れてください。"

  if(!privacyContent || !privacyCheck || !submitBtn || !privacyError) return;

  submitBtn.addEventListener("click", (e:any) => {
    if(privacyCheck.checked == false) {
      e.preventDefault();
      submitBtn.disabled = true;
      privacyError.classList.add("show");
      privacyError.innerHTML = errorMsg
    }
    else {
      submitBtn.removeAttribute('disabled');
      privacyError.classList.remove("show")
    }
  })

  privacyContent.addEventListener("scroll", () => {
    let boxHeight = privacyContent.scrollHeight - privacyContent.clientHeight;
    console.log(boxHeight);
    console.log(privacyContent.scrollTop);
    if(privacyContent.scrollTop >= boxHeight - 100) {
      privacyCheck.removeAttribute('disabled');
    }
  })

  privacyCheck.addEventListener("click", () => {
    if(privacyCheck.checked == false) {
      submitBtn.disabled = true;
      privacyError.classList.add("show");
      privacyError.innerHTML = errorMsg
    }
    else {
      submitBtn.removeAttribute('disabled');
      privacyError.classList.remove("show")
    }
  })
}

export default orderPrivacy
